module.exports = __webpack_public_path__ + "media/stop-2.40c37f04.mp3";